__turbopack_context__.v({
  "container": "OutletSearchResultItem-module-scss-module__NoiIZG__container",
  "leftAccessory": "OutletSearchResultItem-module-scss-module__NoiIZG__leftAccessory",
});
